// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__WNlPw","gfeWrapper":"CalendarEvent_gfeWrapper__IIg73"};